import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EEF1FE', // Lightest - very pale blue
      100: '#D4DBFC', // Extra light
      200: '#B0BCFA', // Light
      300: '#8C9DF7', // Medium light
      400: '#687EF5', // Light medium
      500: '#405FDB', // Your base color
      600: '#3651C4', // Medium dark
      700: '#2C43AD', // Dark
      800: '#223596', // Darker
      900: '#18277F', // Very dark
      950: '#0E1A68', // Darkest
    },
    colorScheme: {
      light: {
        formField: {
          borderColor: '#E5E5E5',
          background: 'white',
          boxShadow: '0px 1px 2px 0px #0000000D',
          hoverBorderColor: '{primary.200}',
          placeholderColor: '#9ca3af',
          borderRadius: '4px',
        },
      },
    },
    components: {
      checkbox: {
        colorScheme: {
          light: {
            root: {
              width: '18px !important',
              height: '18px !important',
              borderRadius: '50px',
              checkedBackground: '{primary.500}',
              borderColor: '#d4d4d4 !important',
              // checkedHoverBackground:
              //   'linear-gradient(180deg, #A0B0F0 0%, #405FDB 81.25%) !important',
              checkedHoverBorderColor: '{primary-50} !important',
              // shadow:
              //   '0px 1px 0.8px 1px rgba(255, 255, 255, 0.23) inset, 0px 0px 0px 0.4px rgba(0, 0, 0, 0.08) !important',
            },
            icon: {
              size: '12px !important',
            },
          },
        },
      },
      toggleswitch: {
        colorScheme: {
          light: {
            root: {
              width: '28px !important',
              height: '14px !important',
              gap: '1px !important',
              // checkedBackground: 'linear-gradient(180deg, #A0B0F0 0%, #405FDB 81.25%) !important',
              // shadow: '0px 0px 0px 0.4px #00000014',
              // borderWidth: '0 !important',
              // checkedHoverBackground:
              //   'linear-gradient(180deg, #A0B0F0 0%, #405FDB 81.25%) !important',
              // checkedHoverBorderColor: '#405FDB !important',

              // focusRing: {
              //   shadow: '0px 0px 0px 0.4px #00000014 !important',
              // },
            },
            // handle: {
            //   background: 'white',
            // },
          },
        },
      },
      radiobutton: {
        colorScheme: {
          light: {
            root: {
              checkedBackground: '{primary.500}',
              borderColor: '#d4d4d4 !important',
              // checkedHoverBackground:
              //   'linear-gradient(180deg, #A0B0F0 0%, #405FDB 81.25%) !important',
              // shadow: '0px 1px 0.8px 1px #FFFFFF3B inset, 0px 0px 0px 0.4px #00000014 !important',
              // checkedHoverBorderColor: '{primary-50} !important',
              // checkedBorderColor: '{primary-50} !important',
            },
          },
        },
      },
      popover: {
        colorScheme: {
          light: {
            root: {
              content: {
                padding: '0 !important',
              },
            },
          },
        },
      },
      button: {
        colorScheme: {
          light: {
            root: {
              borderRadius: '8px !important',
              roundedBorderRadius: '8px !important',
              raisedShadow: '0px 1px 2px 2px #0000001f, 0px 0px 0px 0.8px #415abd !important',
              sm: {
                fontSize: '12px',
                paddingX: '12px !important',
              },
              primary: {
                hoverBackground: '{primary.600} !important',
              },

              secondary: {
                background: '#73737314 !important',
                borderColor: '#E6E6FF !important',
                hoverBackground: '#f7f7f7 !important',
              },
            },
          },
        },
      },
    },
  },
});

export default MyPreset;
